import React, { useState, useMemo, FormEvent } from 'react'
import { Form, Checkbox, Dropdown, DropdownProps, CheckboxProps } from 'semantic-ui-react'
import { QuestionProps } from '../../api/Data'

const MultiSelectQuestion: React.FC<QuestionProps<string[]>> = ({
  question,
  value = [],
  onChange,
  clipIndex,
  errorMessage,
}) => {
  const [searchQuery, setSearchQuery] = useState<string>('')

  const options = useMemo(() => {
    const allOptions: string[] = [
      ...(question.options || []),
      ...(question.datasetKeys?.map((key) => key.value) || [])
    ]

    // Convert to array from Set in a way that avoids the iteration error
    return Array.from(new Set(allOptions))
  }, [question])

  const useCheckboxes = options.length > 0 && options.length < 12

  const dropdownOptions = useMemo(() => {
    return options.map((option) => ({
      key: option,
      text: option,
      value: option,
    }))
  }, [options])

  const handleCheckboxChange = (e: FormEvent<HTMLInputElement>, data: CheckboxProps) => {
    if (!data.label) return

    let newValue = [...(Array.isArray(value) ? value : [])]

    if (data.checked) {
      newValue.push(data.label.toString())
    } else {
      newValue = newValue.filter((item) => item !== data.label)
    }

    onChange(`question_${question.id}_${clipIndex}`, newValue, clipIndex)
  }

  const handleDropdownChange = (e: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    onChange(`question_${question.id}_${clipIndex}`, data.value as string[], clipIndex)
    setSearchQuery('')
  }

  const handleSearchChange = (e: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    setSearchQuery(data.searchQuery || '')
  }

  return (
    <Form.Field required>
      <label>{question.text}</label>

      {useCheckboxes ? (
        <div style={{
          marginTop: '10px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '15px'
        }}>
          {options.map((option) => (
            <div key={option} style={{ marginBottom: '10px' }}>
              <Checkbox
                label={option}
                name={`question_${question.id}_${clipIndex}`}
                value={option}
                checked={Array.isArray(value) && value.includes(option)}
                onChange={handleCheckboxChange}
              />
            </div>
          ))}
        </div>
      ) : (
        <Dropdown
          placeholder="Select options"
          fluid
          multiple
          selection
          search
          value={Array.isArray(value) ? value : []}
          options={dropdownOptions}
          onChange={handleDropdownChange}
          onSearchChange={handleSearchChange}
          searchQuery={searchQuery}
          error={errorMessage ? errorMessage.includes(`${clipIndex}-question_${question.id}_${clipIndex}`) : false}
        />
      )}

      {errorMessage && errorMessage.includes(`${clipIndex}-question_${question.id}_${clipIndex}`) && (
        <div className="ui pointing red basic label">This field is required</div>
      )}
    </Form.Field>
  )
}

export default MultiSelectQuestion
